import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-ask',
  templateUrl: './dialog-ask.component.html',
  styleUrls: ['./dialog-ask.component.scss']
})

export class DialogAskComponent implements OnInit {
  ngOnInit() {}
  constructor(
      public dialogRef: MatDialogRef<DialogAskComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onNoClick(): void {
      this.dialogRef.close();
  }

}
